export default __webpack_public_path__ + "static/media/word.3112175c.png";